import { CheckStripeSubscriptionRequestDto, CheckStripeSubscriptionResponseDto } from "@/lib/interfaces/onboarding";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApiRequest from "../../../lib/hooks/useRequest";
import { Input } from "../../../ui/components/ui/input";
import { SubscriptionContent } from "../../subscriptions/SubscriptionContent";

const PaymentStep = () => {
  const navigate = useNavigate();
  const { apiRequest } = useApiRequest();
  const [loading, setLoading] = useState(true);
  const [showBillingMailInput, setShowBillingMailInput] = useState(false);
  const [billingEmail, setBillingEmail] = useState("");
  const [billingError, setBillingError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const checkSubscription = async () => {
      setLoading(true);
      const response = await apiRequest<CheckStripeSubscriptionResponseDto>("stripe/check-subscription", "POST");
      if (cancelled) return;

      if (!response.error && response.data?.connected) {
        navigate("/");
        return;
      }

      setLoading(false);
    };

    void checkSubscription();

    return () => {
      cancelled = true;
    };
  }, [apiRequest, navigate]);

  const handleBillingCheck = async () => {
    setBillingError(null);

    const payload: CheckStripeSubscriptionRequestDto = {
      billingEmail: billingEmail.trim(),
    };

    const response = await apiRequest<CheckStripeSubscriptionResponseDto>("stripe/check-subscription", "POST", {
      body: payload,
    });

    if (response.error) return;

    if (response.data?.connected) {
      navigate("/");
      return;
    }

    setBillingError("Kein aktives Abonnement für diese E-Mail gefunden. Bitte prüfen Sie Ihre Eingabe.");
  };

  if (loading) {
    return (
      <div className="py-20 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Zahlung wird geprüft</h1>
        <p className="text-sm text-gray-500">Bitte einen Moment Geduld...</p>
      </div>
    );
  }

  return (
    <div>
      <p className="text-sm font-medium mb-1" style={{ color: "#0099ce" }}>
        Schritt 9 von 9
      </p>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Paket auswählen</h1>
      <p className="text-sm text-gray-500 mb-6">
        Wählen Sie ein Paket, um Kandidat.io freizuschalten. Falls bereits ein Abo besteht, können Sie es unten
        verknüpfen.
      </p>

      <div className="rounded-xl bg-white shadow-sm border border-gray-100 p-4 sm:p-5 md:p-8">
        <SubscriptionContent
          footer={
            <div className="border-t border-gray-100 pt-6">
              {!showBillingMailInput ? (
                <button
                  type="button"
                  className="text-primary underline text-sm"
                  onClick={() => setShowBillingMailInput(true)}
                >
                  Bereits ein Abonnement?
                </button>
              ) : (
                <div className="space-y-3 w-full max-w-md">
                  <label className="text-sm font-medium text-gray-700 block">E-Mail des Abonnements</label>
                  <Input
                    value={billingEmail}
                    onChange={(e) => setBillingEmail(e.target.value)}
                    placeholder="billing@example.com"
                    type="email"
                  />
                  <button
                    type="button"
                    onClick={handleBillingCheck}
                    className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:opacity-90 transition-colors"
                  >
                    Abonnement prüfen
                  </button>
                  {billingError ? <p className="text-sm text-red-600">{billingError}</p> : null}
                </div>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default PaymentStep;
